export var OrderPaymentInformationPhaseEnum;
(function (OrderPaymentInformationPhaseEnum) {
    OrderPaymentInformationPhaseEnum["PREAUTH_CHARGE_TRANSACTION_SUCCESS"] = "PREAUTH_CHARGE_TRANSACTION_SUCCESS";
    OrderPaymentInformationPhaseEnum["PREAUTH_CHARGE_TRANSACTION_FAILED"] = "PREAUTH_CHARGE_TRANSACTION_FAILED";
    OrderPaymentInformationPhaseEnum["PREAUTH_REFUND_TRANSACTION_DONE"] = "PREAUTH_REFUND_TRANSACTION_DONE";
    OrderPaymentInformationPhaseEnum["PREAUTH_REFUND_TRANSACTION_FAILED"] = "PREAUTH_REFUND_TRANSACTION_FAILED";
    OrderPaymentInformationPhaseEnum["PREAUTH_DONE"] = "PREAUTH_DONE";
    OrderPaymentInformationPhaseEnum["FULL_PAID"] = "FULL_PAID";
})(OrderPaymentInformationPhaseEnum || (OrderPaymentInformationPhaseEnum = {}));
//# sourceMappingURL=OrderPaymentInformationPhaseEnum.js.map